import React, { forwardRef } from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

const EmptySpaceContent = forwardRef(
  (
    {
      image,
      text,
      linkShow = null,
      linkText = null,
      onClick,
      customClass = '',
      rotation = 'vertical',
    },
    ref
  ) => (
    <div
      className={classNames(
        'flex justify-center items-center font-large text-center rounded-md bg-gray-00 relative h-[55vh]',
        customClass
      )}
    >
      <div
        className={classNames(
          'flex items-center font-family-[Barlow] font-semibold',
          {
            'flex-col': rotation === 'vertical',
            'flex-row gap-6': rotation === 'horizontal',
          }
        )}
      >
        <div className="animate-bounce-in">{image}</div>

        <span
          className={classNames('text-gray-04 animate-fade-in', {
            'mt-[50px]': rotation === 'vertical',
          })}
        >
          {text}
        </span>

        {linkShow && (
          <button
            type="button"
            className={classNames('flex items-center bg-transparent border-0', {
              'mt-6 pb-6': rotation === 'vertical',
              'ml-4': rotation === 'horizontal',
            })}
            onClick={onClick}
          >
            <span className="text-indigo-02">{linkText}</span>
            <Icons.Arrow customClass="ml-2 text-indigo-02 font-semibold" />
          </button>
        )}
      </div>
    </div>
  )
);

export default EmptySpaceContent;
